export default __webpack_public_path__ + "static/media/Maximize.1226e7a3.ttf";